import { baseRoute } from '../../constants/routes';

export const DIPLOMA_DATA_ROUTE = baseRoute + '/diplom';

export const PUT_DIPLOMA = 'PUT_SEND_DIPLOMA';
export const PUT_DIPLOMA_SUCCCESS = 'PUT_DIPLOMA_SUCCESS';
export const POST_DIPLOMA = 'POST_DIPLOMA';
export const POST_DIPLOMA_SUCCCESS = 'POST_DIPLOMA_SUCCESS';

export const GET_DIPLOMA = 'GET_SEND_DIPLOMA';
export const GET_DIPLOMA_SUCCCESS = 'GET_DIPLOMA_SUCCESS';

export const DELETE_DIPLOMA = 'DELETE_SEND_DIPLOMA';
export const DELETE_DIPLOMA_SUCCCESS = 'DELETE_DIPLOMA_SUCCESS';